// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a1c6ca0f","247":"392af065","284":"af687065","453":"92f549a9","459":"0925b37f","627":"acf95fb3","768":"41adce88","923":"ea85bb5e","938":"0fcd171d"}[chunkId] + ".chunk.js";
};